import axios from "axios";
export const getAppList = () => {
  return axios.request({
    url: "/api/app/userVisibleAppLists",
    method: "get"
  });
};
export const getCurrentAppFavorites = () => {
  return axios.request({
    url: "/api/app/favorites/current",
    method: "get"
  });
};
export const saveCurrentAppFavorites = appIds => {
  return axios.request({
    url: "/api/app/favorites/current",
    method: "post",
    data: {
      appIds
    }
  });
};
export const userEditableApps = () => {
  return axios.request({
    url: "/api/app/userEditableApps",
    method: "get"
  });
};
// export const userEditableApps = () => {
//   return axios.request({
//     url: "/api/app/userVisibleApps",
//     method: "get",
//   });
// };
export const assertionSMAL2 = code => {
  return axios.request({
    url: `/api/sso/${code}/assertion`,
    method: "get",
    headers: {
      nomsg: true
    }
  });
};
export const countChildUnits = data => {
  return axios.request({
    url: "/api/unit/countChildUnits",
    method: "get",
    data
  });
};
export const getApp = appCode => {
  return axios.request({
    url: `/api/app/findAppByCode?code=${appCode}`,
    method: "get"
  });
};
// 通讯录同步应用需用 appId 区分同一上游系统下的配置，其他应用沿用原请求。
export const getUpstreamUnitConfig = (upstream, appId) => {
  return axios.request({
    url: `/api/v2/binding/getUpstreamUnitConfig/${upstream}`,
    method: "get",
    params: appId ? {
      appId
    } : undefined
  });
};
export const configApp = data => {
  return axios.request({
    url: `/api/app/configApp`,
    method: "post",
    data
  });
};
export const configDingTalk = data => {
  return axios.request({
    url: `/api/sync/configDingTalk`,
    method: "post",
    data
  });
};
// 同步应用的 appId 放在 Query，凭据仍按接口约定放在 Body。
export const editUpstreamUnitConfig = (upstream, data, appId) => {
  return axios.request({
    url: `/api/v2/binding/editUpstreamUnitConfig/${upstream}`,
    method: "post",
    params: appId ? {
      appId
    } : undefined,
    data
  });
};
export const checkDingDing = params => {
  return axios.request({
    url: `/api/sync/checkDingTalkConfig`,
    method: "get",
    headers: {
      nomsg: true
    },
    params
  });
};
export const configAppScope = data => {
  return axios.request({
    url: `/api/app/configAppScope`,
    method: "post",
    data
  });
};
export const editAccountCreationConfig = (downstream, data) => {
  return axios.request({
    url: `/api/v2/binding/editAccountCreationConfig/${downstream}`,
    method: "post",
    data
  });
};
export const syncUsers = (upstream, data = {}) => {
  return axios.request({
    url: `/api/v2/binding/syncUsers/${upstream}`,
    method: "post",
    data
  });
};
// 企微双应用通过 Query 中的 appId 指定本次同步使用的通讯录应用，请求不携带 Body。
export const syncWechatWorkUsers = appId => {
  return axios.request({
    url: "/api/v2/binding/syncUsers/WE_CHAT_WORK_PRIVATE",
    method: "post",
    params: {
      appId
    }
  });
};
export const startPositionSyncTask = data => {
  return axios.request({
    url: `/api/v2/binding/positionSyncTask/start`,
    method: "post",
    data
  });
};
export const unitAppDetail = appId => {
  return axios.request({
    url: `/api/app/unitAppDetail/${appId}`,
    method: "get"
  });
};
export const getAccountCreationConfig = downstream => {
  return axios.request({
    url: `/api/v2/binding/getAccountCreationConfig/${downstream}`,
    method: "get"
  });
};
export const getNeedUserCodeRule = () => {
  return axios.request({
    url: `/api/v2/binding/needUserCodeRule`,
    method: "get",
    headers: {
      nomsg: true
    }
  });
};
export const checkDingHistory = () => {
  return axios.request({
    url: `/api/sync/listDingTalkSyncHistories`,
    method: "get"
  });
};
export const initialLanguageCurrent = data => {
  return axios.request({
    url: `/api/app/initialLanguage/current`,
    method: "get",
    params: {
      ...data
    }
  });
};
export const asyncDing = () => {
  return axios.request({
    url: `/api/sync/dingTalkSync`,
    method: "post"
  });
};
export const initialLanguageEdit = data => {
  return axios.request({
    url: `/api/app/initialLanguage/edit`,
    method: "post",
    data
  });
};
export const configSyncSwitchDingTalk = data => {
  return axios.request({
    url: `/api/sync/configSyncSwitchDingTalk`,
    method: "post",
    data
  });
};
export const getSyncSwitchConfig = params => {
  return axios.request({
    url: `/api/sync/getSyncSwitchConfig`,
    method: "get",
    params
  });
};
// 校验已保存的凭据时按 appId 选择对应的企微应用。
export const checkUpstreamConfig = (upstream, appId) => {
  return axios.request({
    url: `/api/v2/binding/checkUpstreamConfig/${upstream}`,
    method: "post",
    params: appId ? {
      appId
    } : undefined
  });
};
export const departmentBindingTree = data => {
  return axios.request({
    url: `/api/v2/binding/departmentBindingTree`,
    method: "post",
    data,
    // 部门树处理较慢，单独允许等待 60 秒。
    timeout: 60000
  });
};
export const saveDepartmentMappings = data => {
  return axios.request({
    url: `/api/v2/binding/saveDepartmentMappings`,
    method: "post",
    data
  });
};
export const roleBindingTree = data => {
  return axios.request({
    url: `/api/v2/binding/roleBindingTree`,
    method: "post",
    data
  });
};
export const saveRoleMappings = data => {
  return axios.request({
    url: `/api/v2/binding/saveRoleMappings`,
    method: "post",
    data
  });
};
export const saveDepartmentUnitMappings = data => {
  return axios.request({
    url: `/api/v2/binding/saveDepartmentUnitMappings`,
    method: "post",
    data
  });
};

//应用排序
export const editCustomAppOrder = data => {
  return axios.request({
    url: `/api/app/editCustomAppOrder`,
    method: "post",
    data
  });
};